import { useEffect } from 'react';

import {
	useAvailableSitesState,
	useProjectsState,
	useMappingsActions,
} from '../providers/BulkConfigureContextProvider';
import { useBulkCreateLoggingEvents } from '../utils/useBulkCreateLoggingEvents';

import { fetchJiraComponents } from './apiUtils';

export const FETCH_PROJECT_COMPONENTS = 'fetch-project-components';

export const useGetJiraProjectComponents = () => {
	const { logRequestFailed } = useBulkCreateLoggingEvents();

	const { selectedAvailableSite } = useAvailableSitesState();
	const { selectedProject } = useProjectsState();
	const { setMappingAvailableComponents } = useMappingsActions();

	useEffect(() => {
		const cloudId = selectedAvailableSite?.cloudId;
		const projectId = selectedProject?.id;
		if (!cloudId || !projectId) {
			return;
		}

		const fetchComponents = async () => {
			try {
				const components = await fetchJiraComponents({ cloudId, projectId });
				setMappingAvailableComponents(components ?? []);
			} catch (error: Error | unknown) {
				logRequestFailed({
					requestName: FETCH_PROJECT_COMPONENTS,
					errorMessage: (error as Error).message,
				});
			}
		};
		void fetchComponents();
	}, [selectedAvailableSite, selectedProject, logRequestFailed, setMappingAvailableComponents]);
};
